export default {"src":"/_next/static/media/optimism-explorer.0eee23ad.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};